import React from 'react'

export const Overlay = () => {
  return <div className="cover-layer"></div>
}
